export const status = {
  'READY': 'READY',
  'PLAYING': 'PLAYING',
  'ALREADY_PLAYING': 'ALREADY_PLAYING',
  'NEED_MORE_PLAYERS': 'NEED_MORE_PLAYERS',
  'TIMEOUT': 'TIMEOUT',
  'WRONG_SYMBOL': 'WRONG_SYMBOL',
  'SUCCESS': 'SUCCESS',
  'DISABLED': 'DISABLED',
  'WRONG': 'WRONG'
}